import { BusinessFormCreateProps } from "./BusinessFormCreate";
import { BusinessFormFragment } from "./BusinessFormFragment";
import { SupplierFormFragment } from "../supplier/SupplierFormFragment";
import {
  type BusinessFormApi,
  type BusinessFormType,
} from "./BusinessFormValues";
import { invalidFieldClassName } from "./formValidation";

export const BusinessForm = ({
  form,
  type,
  lockEmail = false,
  metadata,
  formId,
  requireEntityType = false,
}: {
  form: BusinessFormApi;
  type: BusinessFormType;
  lockEmail?: boolean;
  metadata?: BusinessFormCreateProps["metadata"];
  formId?: string;
  requireEntityType?: boolean;
}) => {
  const invalidFieldSelector = `.${invalidFieldClassName.split(" ")[0]}`;

  return (
    <form
      id={formId}
      className={"flex flex-col gap-6"}
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        const formElement = event.currentTarget;

        void Promise.resolve(form.handleSubmit()).then(() => {
          window.requestAnimationFrame(() => {
            const firstInvalidField =
              formElement.querySelector<HTMLElement>(invalidFieldSelector);

            firstInvalidField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });

            firstInvalidField
              ?.querySelector<HTMLElement>("input, select, textarea, button")
              ?.focus({ preventScroll: true });
          });
        });
      }}
    >
      <BusinessFormFragment
        metadata={metadata}
        form={form}
        type={type}
        lockEmail={lockEmail}
        requireEntityType={requireEntityType}
      />
      {type === "supplier" && (
        <SupplierFormFragment form={form} path={"Supplier"} />
      )}
    </form>
  );
};
